// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__m-Q1r","content":"styles_content__fT5_i","checkbox":"styles_checkbox__JFLZB","checkboxLabel":"styles_checkboxLabel__1HBZ3"};